var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAtfNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_10001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28777 15.8602C10.6779 7.58969 11.2656 0.499042 9.60045 0.0228394C7.93529 -0.453364 4.64781 5.8652 2.25767 14.1357C-0.132474 22.4063 -0.720186 29.4969 0.944979 29.9731C2.61014 30.4493 5.89762 24.1308 8.28777 15.8602Z",
    fill: "#B3CDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.172 29.788C20.8166 29.2454 19.9422 22.184 17.219 14.0159C14.4958 5.84773 10.955 -0.334027 9.31048 0.20853C7.66593 0.751088 8.54035 7.81251 11.2635 15.9806C13.9867 24.1488 17.5275 30.3305 19.172 29.788Z",
    fill: "#1A6ED3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_10001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAtfNoText);
export default __webpack_public_path__ + "static/media/logo-atf-no-text.0f669ec6f4f82ad58a67f76443a36100.svg";
export { ForwardRef as ReactComponent };